import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/erfolgreiche-bewerbungsmappe-so-ueb-1.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')